//****************************************
// Plot Legend Helpers Prototype
// DOM Registration: Not an element
// National Instruments Copyright 2015
//****************************************

(function () {
    'use strict';
    // Static Private Reference Aliases
    var NI_SUPPORT = NationalInstruments.HtmlVI.NISupport;
    var $ = NationalInstruments.Globals.jQuery;

    var TargetShapeOptions = Object.freeze({
        Ellipse: 'Ellipse',
        Rectangle: 'Rectangle',
        Diamond: 'Diamond',
        Cross: 'Cross',
        Plus: 'Plus'
    });

    var CrosshairStyleOptions = Object.freeze({
        None: 'No style',
        Vertical: 'Vertical',
        Horizontal: 'Horizontal',
        Both: 'Both'
    });

    // Constructor Function
    NationalInstruments.HtmlVI.Elements.CursorLegendHelpers = function () {
        this.graph = null;
        this.isInEditMode = false;
        this.cursors = [];
        this.defaultCursorName = NI_SUPPORT.i18n('msg_defaultcursorname');
        this.targetShapeOptions = TargetShapeOptions;
        this.crosshairStyleOptions = CrosshairStyleOptions;
    };

    // Static Public Variables
    // None

    var child = NationalInstruments.HtmlVI.Elements.CursorLegendHelpers;
    var proto = child.prototype;

    // Static Private Variables
    // None

    // Static Private Functions
    // None

    // Public Prototype Methods
    proto.getMenuItem = function (name) {
        if (name === 'shape') {
            return {
                name: 'Target Shape',
                tag: 'msg_targetshape',
                children: [
                    { name: TargetShapeOptions.Ellipse, tag: 'msg_ellipse', cssClass: 'ni-ellipse-point-style-icon' },
                    { name: TargetShapeOptions.Rectangle, tag: 'msg_rectangle', cssClass: 'ni-rect-point-style-icon' },
                    { name: TargetShapeOptions.Diamond, tag: 'msg_diamond', cssClass: 'ni-diamond-point-style-icon' },
                    { name: TargetShapeOptions.Cross, tag: 'msg_cross', cssClass: 'ni-cross-point-style-icon' },
                    { name: TargetShapeOptions.Plus, tag: 'msg_plus', cssClass: 'ni-plus-point-style-icon' }
                ]
            };
        } else if (name === 'crosshair') {
            return {
                name: 'Crosshair Style',
                tag: 'msg_crosshairstyle',
                children: [
                    { name: CrosshairStyleOptions.None, tag: 'msg_nostyle', cssClass: 'ni-no-crosshair-icon' },
                    { name: CrosshairStyleOptions.Vertical, tag: 'msg_vertical', cssClass: 'ni-vertical-crosshair-icon' },
                    { name: CrosshairStyleOptions.Horizontal, tag: 'msg_horizontal', cssClass: 'ni-horizontal-crosshair-icon' },
                    { name: CrosshairStyleOptions.Both, tag: 'msg_both', cssClass: 'ni-both-crosshair-icon' }
                ]
            };
        }
    };

    proto.cursorAdded = function (cursor) {
        if (this.getIndex(cursor) === -1) {
            this.cursors.push(cursor);
        }
    };

    // if cursor is not already removed from the list then remove it
    proto.cursorRemoved = function (cursor) {
        this.cursors.splice(this.getIndex(cursor), 1);
    };

    proto.addCursor = function () {
        var graph = this.graph;
        var cursor = document.createElement('ni-cursor');
        cursor.show = true;
        cursor.showValue = true;
        this.cursors.push(cursor);
        cursor.label = this.nextCursorName();
        graph.appendChild(cursor);
    };

    proto.cursorPositionChanged = function (cursor, changed) {
        // TODO mraj is undefined an expected value?
        if (cursor === undefined) {
            throw new Error('cursor is undefined');
        }

        $(cursor).on('cursorUpdated', function (e, data) {
            changed(data);
        });
    };

    proto.clearCache = function () {
        this.cursors.length = 0;
    };

    proto.getCursor = function (index) {
        var i = 0;
        var graph;
        var cursor = null;
        var child;
        if (this.cursors[index] === null || this.cursors[index] === undefined) {
            graph = this.graph;
            if (graph !== null) {
                for (child in graph.childNodes) {
                    if (graph.childNodes[child].localName === 'ni-cursor') {
                        if (i === index) {
                            cursor = graph.childNodes[child];
                            break;
                        }

                        i++;
                    }
                }
            }

            if (cursor !== null) {
                this.cursors[index] = cursor;
            }
        }

        return this.cursors[index];
    };

    proto.nextCursorName = function () {
        var maxIndex = 0, i, cursor;
        var graph = this.graph;
        if (graph !== null) {
            for (child in graph.childNodes) {
                if (graph.childNodes[child].localName === 'ni-cursor') {
                    cursor = graph.childNodes[child];
                    i = parseInt(cursor.label.substring(this.defaultCursorName.length));
                    if (i > maxIndex) {
                        maxIndex = i;
                    }
                }
            }
        }

        return this.defaultCursorName + ' ' + (maxIndex + 1);
    };

    proto.deleteCursor = function (cursor) {
        var graph = this.graph;
        if (cursor !== null && cursor !== undefined) {
            graph.removeChild(cursor);
        }
    };

    proto.getIndex = function (cursor) {
        return this.cursors.indexOf(cursor);
    };

    proto.handleClick = function (itemName, arg, cursor) {
        if (cursor === null && cursor === undefined) {
            return;
        }

        switch (itemName) {
            case 'name':
                break;
            case 'x':
                break;
            case 'y':
                break;
            case 'visible':
                cursor.show = !cursor.show;
                break;
            case 'snap':
                cursor.snapToPlot = cursor.snapToPlot !== -1 ? -1 : undefined;
                break;
            case 'center':
                cursor.snapToPlot = undefined;
                cursor.x = 0.5;
                cursor.y = 0.5;
                break;
            case 'delete':
                this.deleteCursor(cursor);
                break;
            case TargetShapeOptions.Ellipse:
                cursor.targetShape = 'ellipse';
                break;
            case TargetShapeOptions.Rectangle:
                cursor.targetShape = 'rectangle';
                break;
            case TargetShapeOptions.Diamond:
                cursor.targetShape = 'diamond';
                break;
            case TargetShapeOptions.Cross:
                cursor.targetShape = 'cross';
                break;
            case TargetShapeOptions.Plus:
                cursor.targetShape = 'plus';
                break;
            case CrosshairStyleOptions.None:
                cursor.crosshairStyle = 'none';
                break;
            case CrosshairStyleOptions.Vertical:
                cursor.crosshairStyle = 'vertical';
                break;
            case CrosshairStyleOptions.Horizontal:
                cursor.crosshairStyle = 'horizontal';
                break;
            case CrosshairStyleOptions.Both:
                cursor.crosshairStyle = 'both';
                break;
            case 'Color':
                cursor.setColor(arg);
                break;
        }
    };

    proto.getState = function (itemName, cursor) {
        if (cursor === null || cursor === undefined) {
            return undefined;
        }

        var state;
        switch (itemName) {
            case 'name':
                state = cursor.label;
                break;
            case 'x':
                state = cursor.x;
                break;
            case 'y':
                state = cursor.y;
                break;
            case 'visible':
                state = cursor.show;
                break;
            case 'snap':
                state = cursor.snapToPlot === -1;
                break;
            case 'center':
                break;
            case 'delete':
                break;
            case TargetShapeOptions.Ellipse:
                state = cursor.targetShape === 'ellipse';
                break;
            case TargetShapeOptions.Rectangle:
                state = cursor.targetShape === 'rectangle';
                break;
            case TargetShapeOptions.Diamond:
                state = cursor.targetShape === 'diamond';
                break;
            case TargetShapeOptions.Cross:
                state = cursor.targetShape === 'cross';
                break;
            case TargetShapeOptions.Plus:
                state = cursor.targetShape === 'plus';
                break;
            case CrosshairStyleOptions.None:
                state = cursor.crosshairStyle === 'none';
                break;
            case CrosshairStyleOptions.Vertical:
                state = cursor.crosshairStyle === 'vertical';
                break;
            case CrosshairStyleOptions.Horizontal:
                state = cursor.crosshairStyle === 'horizontal';
                break;
            case CrosshairStyleOptions.Both:
                state = cursor.crosshairStyle === 'both';
                break;
            case 'Color':
                state = window.getComputedStyle(cursor).color;
                break;
        }

        return state;
    };

    proto.getTargetShape = function (index) {
        var cursor = this.getCursor(index);
        if (cursor !== null && cursor !== undefined) {
            return cursor.targetShape;
        }

        return 'ellipse';
    };

    proto.getCrosshair = function (index) {
        var cursor = this.getCursor(index);
        if (cursor !== null && cursor !== undefined) {
            return cursor.crosshairStyle;
        }
    };
}());
